import React from "react";
import "./AP.scss";

import kiriatas from "../../Media/Foto About/Kiri_atas.webp";
import kiribawah from "../../Media/Foto About/Kiri_Bawah.webp";
import kananatas from "../../Media/Foto About/Kanan_Atas.webp";
import kananbawah from "../../Media/Foto About/Kanan_Bawah.webp";
import {faCheckDouble} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const SecondHero = () => {
  return (
    <div className="secondherocontainerAP" id="about">
      <div className="secondmiddle">
        <div className="rightcontent">
          <div className="leftpicture">
            <div className="kiriatas">
              <img src={kiriatas} className="satu" alt="Nava" />
            </div>
            <div className="kiribawah">
              <img src={kiribawah} className="dua" alt="Nava" />
            </div>
          </div>
          <div className="rightpicture">
            <div className="kananatas">
              <img src={kananatas} className="tiga" alt="Nava" />
            </div>
            <div className="kananbawah">
              <img src={kananbawah} className="empat" alt="Nava" />
            </div>
          </div>
        </div>
        <div className="leftcontent">
          <div className="content-judul">
            <h1>The Mutiara Bogor</h1>
            <h2>Where Elegance Meets Convenience</h2>
          </div>
          <div className="contentdescription">
            The Mutiara Bogor adalah hunian modern bernuansa alam dengan akses
            strategis di dekat Tol Jagorawi. Menghadirkan desain elegan, suasana
            sejuk khas Bogor, dan fasilitas lengkap untuk keluarga. Hunian
            premium bagi Anda yang menginginkan kenyamanan, gaya hidup modern,
            dan kedekatan dengan alam.
          </div>
          <div className="container-benefit">
            <div className="benefit-list">
              <div className="penawaranpoin">
                <FontAwesomeIcon icon={faCheckDouble} color="#576F66" />
                <span style={{color: "rgba(42, 42, 42, 1)"}}>
                  &nbsp;&nbsp;Jogging Track
                </span>
              </div>
              <div className="penawaranpoin">
                <FontAwesomeIcon icon={faCheckDouble} color="#576F66" />
                <span style={{color: "rgba(42, 42, 42, 1)"}}>
                  &nbsp;&nbsp;Swimming Pool
                </span>
              </div>

              <div className="penawaranpoin">
                <FontAwesomeIcon icon={faCheckDouble} color="#576F66" />
                <span style={{color: "rgba(42, 42, 42, 1)"}}>
                  &nbsp;&nbsp;Children Playground
                </span>
              </div>
              <div className="penawaranpoin">
                <FontAwesomeIcon icon={faCheckDouble} color="#576F66" />
                <span style={{color: "rgba(42, 42, 42, 1)"}}>
                  &nbsp;&nbsp;Tennis & Baskball Court
                </span>
              </div>
              <div className="penawaranpoin">
                <FontAwesomeIcon icon={faCheckDouble} color="#576F66" />
                <span style={{color: "rgba(42, 42, 42, 1)"}}>
                  &nbsp;&nbsp;One Gate System & Security 24 Hours
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecondHero;
